import { render, staticRenderFns } from "./Celebrities.vue?vue&type=template&id=3b193068&"
import script from "./Celebrities.vue?vue&type=script&lang=js&"
export * from "./Celebrities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports